<template>
  <div>
    <div class="TopValidators">
      <div class="TopValidators-W">
        <div class="indexsearch">
          <!-- <div class="title">Transformers Explorer</div> -->

          <div class="seacherc">
            <Homseach></Homseach>
          </div>
        </div>
        <div class="Validators_list">
          <div class="Validators_title">Validators</div>
          <div class="Validators_all">
            <div class="Validators_box">
              <div class="Validators_tit">Validators</div>
              <div class="Validators_cont">
                {{ Number(validatorCount).toLocaleString() }}
              </div>
              <div class="Validators_botm">
                <div class="val_left">{{ nodeCount }}</div>
                <div class="val_right">All nodes</div>
              </div>
            </div>
            <div class="Validators_box Validators_box1">
              <div class="Validators_tit">Total stake</div>
              <div class="Validators_cont">
                {{
                  Number(
                    (Number(totalStake) / 100000000).toFixed(0)
                  ).toLocaleString()
                }}
              </div>
              <div class="Validators_botm">
                <div class="val_left">{{ stakeRate }}%</div>
                <div class="val_right">Stake rate</div>
              </div>
            </div>
            <div class="Validators_box Validators_box2">
              <div class="Validators_tit">Current APY  <el-tooltip
                          placement="right"
                          popper-class="toolTipClass"
                        >
                          <div slot="content">
                            This value represents the current highest Annual<br/>
                            Percentage Yield (APY), with the APY for each<br/>
                            validator determined based on its own workload<br/>
                            value. Specifically, 80% of the annual rewards will<br/>
                            be directly allocated to delegators, while the<br/>
                            remaining 20% will be paid to nodes in the form of<br/>
                            commissions.<br/>
                            <!-- This is the annual staking delegation reward for<br />
                            TTOS , where 80% of the annual reward will
                            directly<br />
                            belong to the delegator, and the remaining 20%
                            will<br />
                            be paid as commission to the node. -->
                            <!-- This is the annualized return on investment for<br />
                            staking TTOS. Of the total, 80% of the<br />
                            annualized return will directly belong to
                            <br />investors, while the remaining 20% will be
                            paid<br />
                            as commission to the nodes. -->
                          </div>
                          <img src="@/assets/pc/Index/tip.png" style="width: 12px;height: 12px;margin-left: 4px;" />
                        </el-tooltip></div>
              <div class="Validators_cont Validators_cont1">
                {{ CurrentAPR * 100 }}%
              </div>
            </div>
            <div class="Validators_box Validators_box3">
              <!-- <TimeBox
                style="background: none"
                :nextDuring="nextDuring"
              ></TimeBox> -->
              <div class="Validators_tit">To the next bonus era</div>
              <div class="Validators_cont">
                {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
              </div>
              <div class="Validators_botm">
                <div style="margin-left: -17px">
                  <el-progress
                    type="line"
                    style="width: 200px !important"
                    :stroke-width="12"
                    :percentage="Number(percentage)"
                    class="el-bg-inner-running"
                  ></el-progress>
                </div>
              </div>
              <!-- <div class="Hblbox_content">
                    {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
                  </div>
                  <div class="Hblbox_bott">
                    <div class="progress">
                      <el-progress
                        type="line"
                        :percentage="Number(percentage)"
                        class="el-bg-inner-running"
                      ></el-progress>
                    </div>
                  
                  </div> -->
            </div>
            <div class="Validators_box Validators_box5">
              <div
                class="Validators_tit"
                style="margin-top: 26px; margin-left: 10px"
              >
                Workload benchmark<el-tooltip
                  placement="right"
                  popper-class="toolTipClass"
                >
                  <div slot="content">
                    The term "Workload Benchmark" refers to the average level of<br/>
                    the entire network workload. When a validator reaches or<br/>
                    surpasses this standard, it signifies excellent performance,<br/>
                    making them eligible to receive the full rewards for the<br/>
                    day. Conversely, if the benchmark is not met, it may<br/>
                    indicate subpar performance, preventing the validator from<br/>
                    obtaining the full rewards. In such cases, they will only be<br/>
                    entitled to receive rewards based on the percentage of<br/>
                    actual workload compared to the workload benchmark<br/>
                    <!-- "Workload benchmark" refers to the target value<br />
                    of the workload. When a validator meets this<br />
                    standard, it indicates that it is in an excellent<br />
                    working condition and eligible to receive<br />
                    rewards. On the other hand, if it fails to meet the<br />
                    benchmark, it may indicate that the validator's<br />
                    state has become invalid, and it will be unable to<br />
                    receive rewards.<br /> -->
                  </div>
                  <img
                    src="@/assets/pc/Index/tip.png"
                    style="width: 12px; height: 12px; margin-left: 4px"
                  />
                </el-tooltip>
              </div>
              <div class="Validators_cont">
                {{ Number(workloadBenchMark).toLocaleString() }}
              </div>
            </div>
            <div class="Validators_box Validators_box4">
              <div class="charts" ref="chart"></div>
              <div class="charts_ul">
                <div
                  class="chartsli"
                  v-for="(item, index) in vdata.slice(0, 3)"
                  :key="index"
                >
                  <div class="leftli">{{ item.version }}</div>
                  <div class="rightli">({{ item.value }} %)</div>
                </div>
                <!-- <div
                  class="chartsli"
                  v-if="vdata.length>2"
                >
                  <div class="leftli">Others</div>
                  <div class="rightli">(1 %)</div>
                </div> -->
                <!-- <div class="chartsli">
                  <div class="leftli">1 _ 0.20.1 _ d</div>
                  <div class="rightli">(75.26%)</div>
                </div> -->
                <!-- <div class="chartsli">
                  <div class="leftli">Others</div>
                  <div class="rightli">(75.26%)</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="TopValidatorsList" v-if="isShow">
          <div class="Block_Top">
            <span>Top validators</span>
            <span>
              <div class="search">
                <input
                  type="text"
                  v-model="value"
                  @keyup.enter="search"
                  placeholder="Search for validation nodes address"
                />
                <img @click="search()" src="@/assets/pc/Index/seach.png" />
              </div>
            </span>
          </div>
          <TopValidatorsList
            :params="Params"
            @ValidakList="ValidakList($event)"
            ref="mychild"
          ></TopValidatorsList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopValidatorsList from "./TopValidators_list";
import { ValidatorRankList } from "@/assets/server/api";
import TimeBox from "@/components/pc/Timebox.vue";
import Homseach from "../../../components/pc/serch.vue";
const echarts = require("echarts");

export default {
  data() {
    return {
      stakeRate: 0,
      //  totalStake: 0,
      yieldOfStake: 0,
      count: 0,
      allNodeSize: 0,
      vdata: [],
      vdata1: [],
      vdataname: "",
      vdatavalue: "",
      value: "",
      Params: "",
      isShow: true,
      LogoImg: require("@/assets/pc/Index/vers.png"),
      flog: false,
      //开始
      CurrentAPR: "",
      stakeRate: "",
      nextDuring: "",
      versionList: [],
      nodeCount: 0, //节点数量
      validatorCount: 0, //验证器数量
      totalStake: 0,
      workloadBenchMark: null,
      theTime: 0, // 秒
      theTime1: 0, // 分
      theTime2: 0, // 时
      percentage: null,
      others: "",
    };
  },
  components: {
    TopValidatorsList,
    TimeBox,
    Homseach,
  },
  created() {
    sessionStorage.removeItem("onlines");
    sessionStorage.removeItem("actives");
    sessionStorage.removeItem("Unactive");
  },
  mounted() {
    this.initCharts();
    this.daojishi();
  },
  methods: {
    mouseOver() {
      this.flog = true;
    },
    mouseLeave() {
      this.flog = false;
    },
    ValidakList(e) {
      //  console.log(e);
      //开始

      this.CurrentAPR = Number(e.CurrentAPR).toFixed(4);
      this.stakeRate = e.stakeRate;
      //  console.log(this.stakeRate);
      this.nextDuring = e.nextDuring / 1000;
      //  console.log(this.nextDuring);
      this.nodeCount = e.nodeCount;
      this.validatorCount = e.validatorCount;
      this.totalStake = e.totalStake;
      this.workloadBenchMark = e.workloadBenchMark;
      //结束
      this.stakeRate = e.stakeRate;
      this.totalStake = e.totalStake;
      this.yieldOfStake = e.yieldOfStake;
      this.count = e.count;
      this.allNodeSize = "/ " + e.allNodeSize;

      if (e.versionList.length > 2) {
        this.sum = 0;
        let suma = 0;
        for (var i = 0; i < e.versionList.length; i++) {
          this.sum += e.versionList[i].nums;
        }

        for (var j = 2; j < e.versionList.length; j++) {
          suma += e.versionList[j].nums;
        }

        e.versionList.splice(2, 5, {
          nums: suma,
          value: suma / this.sum,
          version: "others",
        });
        this.vdata1 = e.versionList;
        // console.log(this.vdata1);
        this.vdata = this.vdata1;
        // console.log(this.vdata);
      } else if (e.versionList.length <= 2) {
        this.sum = 0;

        for (var i = 0; i < e.versionList.length; i++) {
          this.sum += e.versionList[i].nums;
          e.versionList[i].value = e.versionList[i].nums / this.sum;
        }

        this.vdata1 = e.versionList;

        this.vdata = this.vdata1;
      }
      //   console.log(this.vdata1);
      //    console.log(this.vdata);
      this.vdataname = this.vdata[0].version;
      this.vdatavalue = ((this.vdata[0].nums / this.sum) * 100).toFixed(2);
      for (var i = 0; i < this.vdata.length; i++) {
        // if(i>=1){
        this.vdata[i].name = this.vdata[i].version;
        // this.vdata[i].value=this.vdata[i].nums;
        this.vdata[i].value = ((this.vdata[i].nums / this.sum) * 100).toFixed(
          2
        );
        // if(i>=1){
        //   this.vdata1[i].name = this.vdata1[i].version;
        // // this.vdata[i].value=this.vdata[i].nums;
        // this.vdata1[i].value ='('+ ((this.vdata1[i].nums / e.countall) * 100).toFixed(
        //   2
        // )+')'+'%';
      }
      this.initCharts();
    },
    daojishi() {
      this.Time = setInterval(async () => {
        this.nextDuring--;
        this.percentage = (((86400 - this.nextDuring) / 86400) * 100).toFixed(
          1
        );
        this.theTime = parseInt(this.nextDuring); // 需要转换的时间秒
        this.theTime1 = 0; // 分
        this.theTime2 = 0; // 小时
        if (this.theTime > 60) {
          this.theTime1 = parseInt(this.theTime / 60);
          if (this.theTime > 1) {
            this.theTime = parseInt(this.theTime % 60);
          } else {
            this.theTime = 60;
          }
          if (this.theTime1 > 60) {
            this.theTime2 = parseInt(this.theTime1 / 60);
            if (this.theTime1 > 1) {
              this.theTime1 = parseInt(this.theTime1 % 60);
            } else {
              this.theTime1 = 60;
            }
            if (this.theTime2 > 24) {
              //大于24小时
              this.theTime2 = parseInt(this.theTime2 % 24);
            }
          }
        }
      }, 1000);
      //  this.$emit("recordsChange",  this.nextDuring);
    },
    async search() {
      let vlaue1 = this.value.trim();
      sessionStorage.removeItem("onlines");
      sessionStorage.removeItem("actives");

      sessionStorage.removeItem("Unactive");
      if (vlaue1.length > 0) {
        const params = {
          active: "",
          online: "",
          seqType: "",
          seq: "",
          address: vlaue1,
          pageNum: 1,
          pageSize: 20,
        };
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await ValidatorRankList(formData);
        //  console.log(data);
        if (data.code == 200) {
          let IsShows = "";
          if (data.result.validatorList.length > 0) {
            IsShows = true;
          } else {
            IsShows = false;
          }
          sessionStorage.removeItem("qingcu");

          sessionStorage.removeItem("tupian1");
          sessionStorage.removeItem("tupian");
          let ImgList = [];
          for (let i = 0; i < data.result.validatorList.length; i++) {
            data.result.validatorList[i].Progressbar = (
              (data.result.validatorList[i].delegated / 1000000 / 0.065) *
              100
            ).toFixed(2);
            if (data.result.validatorList[i].logo == "") {
              data.result.validatorList[i].logo = this.LogoImg;
              ImgList[i] = data.result.validatorList[i].logo;
            }
          }
          this.Params = {
            ListParams: data.result.validatorList,
            count: data.result.listCount,
            IsShows: IsShows,
            ImgUrl: ImgList,
            address: vlaue1,
          };
        }
      } else {
        //   console.log(1111);

        const params = {
          active: "",
          online: "",
          seqType: "",
          seq: "",
          address: "",
          pageNum: 1,
          pageSize: 20,
        };
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        let data = await ValidatorRankList(formData);
        //   console.log(data);
        if (data.code == 200) {
          sessionStorage.removeItem("qingcu");
          //     sessionStorage.removeItem("onlines");
          // sessionStorage.removeItem("actives");
          sessionStorage.removeItem("tupian1");
          sessionStorage.removeItem("tupian");
          let ImgList = [];
          for (let i = 0; i < data.result.validatorList.length; i++) {
            data.result.validatorList[i].Progressbar = (
              (data.result.validatorList[i].delegated / 1000000 / 0.065) *
              100
            ).toFixed(2);
            if (data.result.validatorList[i].logo == "") {
              data.result.validatorList[i].logo = this.LogoImg;
              ImgList[i] = data.result.validatorList[i].logo;
            }
          }
        }
        // this.seqType = "";
        // this.seq = "";
        // this.Actives = "";
        // this.Onlines = "";
        // this.$refs.mychild.ValidakList(1);
        let IsShows = true;
        this.Params = {
          IsShows: IsShows,
          address: "",
          ListParams: data.result.validatorList,
          count: data.result.listCount,
          active: "",
          online: "",
          // seqType: 'delegated',
          // seq: 'desc',
        };
      }
      this.value = "";
    },

    initCharts() {
      if (
        this.lineChart != null &&
        this.lineChart != "" &&
        this.lineChart != undefined
      ) {
        this.lineChart.dispose();
      }
      //    console.log(this.vdata);
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}({d}%)",
        },
        color: "#00A870",
        title: {
          text: "Node Version",
          x: "3%",
          y: "10%",
          textStyle: {
            fontSize: "12",
            color: "#898B8D",
          },
        },
        // legend: {
        //   bottom: "20px",
        //   show: true,
        //   orient: "vertical",
        //   x: "50%",
        //   y: "32%",
        //   textStyle: {
        //     color: "#8d8d8d",
        //     fontSize: "24px",
        //   },
        //   formatter: function (name) {
        //     console.log(option.series[0].data);
        //     var result = option.series[0].data.slice(0, 3);
        //     var total = 0;
        //     for (var i = 0; i < result.length; i++) {
        //       total += parseFloat(result[i].value);
        //     }
        //     console.log(total);
        //     for (i = 0; i < result.length; i++) {
        //       var dpercent = ((result[i].value / total) * 100).toFixed(2) + "%";
        //       if (result[i].name === name) {
        //         return name + " " + "(" + dpercent + ")";
        //       }
        //     }
        //   },

        //   itemWidth: 0,
        //   itemHeight: 0,
        // },

        series: [
          {
            name: "Node Versions",
            type: "pie",
            radius: ["40%", "64%"],
            center: ["42%", "64%"],
            avoidLabelOverlap: false,
            minAngle: 15,

            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "#232a35",
                color: function (colors) {
                  var colorList = ["#D3F85A", "#00E79A", "#FFD449"];
                  return colorList[colors.dataIndex];
                },
              },
            },

            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 14,
                fontWeight: "bold",
                color: "#fff",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.vdata,
          },
        ],
      };

      this.lineChart.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-progress-bar {
  // border:1px solid red;
  padding-right: 0px !important;
  width: 90% !important;
  margin-right: 0 !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/deep/.el-progress-bar__inner {
  background-image: linear-gradient(to right, #00e79a, #00e79a);
}
.el-progress-bar__outer {
  background: #1e232a !important;
  /* border: 1px solid red; */
  /* width: 160px; */
  margin-left: 0px;
}

.Hblbox_content {
  color: #00e79a !important;
}
</style>
<style lang="less" scoped>
@import url("https://at.alicdn.com/t/font_3404326_3s5grzrpcqy.css");

.TopValidators {
  width: 100%;
  background: #13161b;
  .TopValidators-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .indexsearch {
      width: 1160px;
      background: #13161b;
      display: flex;
      height: 48px;
      justify-content: space-between;
      margin-bottom: 20px;
      margin-top: 52px;
      .title {
        width: 238px;
        // border: 1px solid red;
        margin-top: 20px;
        height: 32px;
        font-size: 22px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 32px;
      }
      .seacherc {
        // margin-top: 20px;
        // margin-bottom: 20px;
        // border: 1px solid red;
        width: 892px;
        // height: 40px;
        // line-height: 40px;
        background: #000000;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        opacity: 1;
        input {
          width: 100%;

          border-radius: 8px 8px 8px 8px;
          border: none;
          padding: 0 20px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #64666a;

          line-height: 24px;
          -webkit-background-clip: text;
        }
        .button {
          width: 40px;
          height: 40px;
          background: #00e79a;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          img {
            width: 16px;
            height: 17px;
            // padding: 20px 12px;
            margin-top: 12px;
            margin-left: 12px;
          }
        }
      }
    }
    .Validators_list {
      width: 1160px;
      height: 240px;
      background: #000000;
      opacity: 1;
      margin-top: 30px;
      border-radius: 16px;

      .Validators_title {
        height: 26px;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 26px;
        padding-top: 30px;
        margin-left: 40px;
      }
      .Validators_all {
        display: flex;

        .Validators_box1 {
          width: 165px !important;
        }
        .Validators_box2 {
          width: 127px !important;
          .Validators_tit {
            margin-top: 17px !important;
          }
          .Validators_cont {
            margin-top: 18px !important;
          }
        }
        .Validators_box3 {
          width: 200px !important;
          // border: 1px solid red;
        }
        .Validators_box5 {
          width: 160px !important;
        }
        .Validators_box4 {
          width: 230px !important;
          display: flex;
          // border: 1px solid red;
          .charts {
            width: 100px;
            height: 130px;
          }
          .charts_ul {
            width: 130px;
            // border: 1px solid red;
            margin-top: 50px;
            margin-left: -10px;
            .chartsli {
              display: flex;
              justify-content: flex-end;
              //  align-content: flex-end;
              height: 24px;
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 24px;
              .leftli {
                font-size: 12px;
              }
              .rightli {
                font-size: 12px;
                color: #fff;
                margin-left: 6px;
              }
            }
          }
        }
        .Validators_box {
          width: 142px;
          height: 134px;
          background: #13161b;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          margin-top: 56px;
          margin-left: 20px;

          .Validators_tit {
            padding-top: 22px;
            margin-left: 20px;
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 17px;
          }
          .Validators_cont1 {
            padding-top: 8px !important;
          }
          .Validators_cont {
            padding-top: 18px;
            margin-left: 20px;
            height: 35px;
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00e79a;
            line-height: 35px;
          }
          .Validators_botm {
            padding-top: 32px;
            margin-left: 20px;
            display: flex;
            .val_left {
              font-size: 12px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #00e79a;
            }
            .val_right {
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.5);
              line-height: 17px;
              margin-left: 8px;
            }
          }
        }
      }
    }

    .TopValidatorsList {
      margin-top: 20px;
      background: #0b0c0f;
      border-radius: 20px 20px 0px 0px;
      .Block_Top {
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
        // span {
        //   flex: 1;
        // }
        .search {
          margin-right: 20px;
          width: 380px;
          height: 40px;
          background: #18191e;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #898b8d;
          // margin-left: 356px;
          display: flex;
          justify-content: space-between;
          input {
            width: 320px;
            height: 40px;
            border: none;
            margin-left: 12px;
            color: #fff;
          }
          img {
            width: 21px;
            height: 21px;
            margin-top: 10px;
            margin-right: 20px;
          }
        }
        span:nth-child(1) {
          margin-left: 26px;
          margin-top: 10px;
          font-size: 16px;
          font-family: SF Pro Text-Medium, SF Pro Text;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          line-height: 24px;
          -webkit-background-clip: text;
        }
      }
    }
  }
}
</style>
